import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { InitialQuestionnaireComponent } from "./questionnaire/initial-questionnaire/initial-questionnaire.component";
import { PreInitialScreenComponent } from "./questionnaire/pre-initial-screen/pre-initial-screen.component";
import { QuestionnaireComponent } from "./questionnaire/questionnaire.component";
import { authGuard } from "./guards/auth.guard";
import { PostInitialScreenComponent } from "./questionnaire/post-initial-screen/post-initial-screen.component";
import { ComprehensiveQuestionnaireComponent } from "./questionnaire/comprehensive-questionnaire/comprehensive-questionnaire.component";
import { PostComprehensiveScreenComponent } from "./questionnaire/post-comprehensive-screen/post-comprehensive-screen.component";
import { PostInitialRegretScreenComponent } from "./questionnaire/post-initial-regret-screen/post-initial-regret-screen.component";
import { RedirectComponent } from "./redirect/redirect.component";
import { HospitalAdminComponent } from "./dashboard/hospital-admin/hospital-admin.component";
import { SignupComponent } from "./signup/signup.component";
import { navigationGuard } from "./guards/navigation.guard";
import { loginRedirectGuard } from "./guards/login-redirect.guard";

import { DonorComponent } from "./dashboard/shared-views/donor/donor.component";
import { BillingOverviewComponent } from "./dashboard/hospital-admin/billing-overview/billing-overview.component";

import { UserOverviewComponent } from "./dashboard/hospital-admin/user-overview/user-overview.component";
import { QuestionnaireOverviewComponent } from "./dashboard/hospital-admin/questionnaire-overview/questionnaire-overview.component";
import { consentSignedGuard } from "./guards/consent-signed.guard";
import { DonorOverviewComponent } from "./dashboard/shared-views/donor-overview/donor-overview.component";
import { ReportingComponent } from "./dashboard/shared-views/reporting/reporting.component";
import { DonorJourneyComponent } from "./donor-journey/donor-journey.component";
import { CoordinatorComponent } from "./dashboard/coordinator/coordinator.component";
import { MrbViewComponent } from "./dashboard/shared-views/mrb-view/mrb-view.component";
import { SynopsisComponent } from "./dashboard/shared-views/synopsis/synopsis.component";
import { ProviderJourneyComponent } from "./dashboard/shared-views/provider-journey/provider-journey.component";


const routes: Routes = [
  {
    path: "",
    redirectTo: "redirect",
    pathMatch: "full",
  },
  {
    path: "redirect",
    canActivate: [authGuard, navigationGuard],
    component: RedirectComponent,
  },
  {
    path: "login",
    canActivate: [loginRedirectGuard],
    component: LoginComponent,
  },
  {
    path: "signup",
    canActivate: [loginRedirectGuard],
    component: SignupComponent,
  },
  {
    path: "questionnaire",
    component: QuestionnaireComponent,
    canActivate: [authGuard],
    canActivateChild: [navigationGuard],
    children: [
      { path: "", redirectTo: "preinitial", pathMatch: "full" },
      { path: "preinitial", component: PreInitialScreenComponent },
      { path: "iquestionnaire", component: InitialQuestionnaireComponent },
      { path: "postinitial", component: PostInitialScreenComponent },
      {
        path: "postinitialineligible",
        component: PostInitialRegretScreenComponent,
      },
      {
        path: "cquestionnaire/section/:sectionIndex",
        component: ComprehensiveQuestionnaireComponent,
      },
      { path: "cquestionnaire", redirectTo: "cquestionnaire/section/0" },
      {
        path: "postcomprehensive",
        component: PostComprehensiveScreenComponent,
        canActivate: [consentSignedGuard],
      },

      // Add more child routes here
    ],
  },
  {
    path: "journey",
    component: DonorJourneyComponent,
    canActivate: [authGuard, navigationGuard, consentSignedGuard],
  },
  {
    path: "hospital/donor/:userId",
    component: DonorComponent,
    canActivate: [authGuard, navigationGuard],
    children: [
      {
        path: "",
        redirectTo: "synopsis",
        pathMatch: "full"
      },
      {
        path: "synopsis",
        component: SynopsisComponent
      },
      {
        path: "journey",
        component: ProviderJourneyComponent
      },
      {
        path: "mrb",
        component: MrbViewComponent,
        canActivate: [authGuard, navigationGuard],
      },
    ]
  },
  {
    path: "hospital/coordinator/dashboard",
    component: CoordinatorComponent,
    canActivate: [authGuard, navigationGuard],
    children: [
      { path: '', redirectTo: 'donoroverview', pathMatch: 'full' },
      { path: 'donoroverview', component: DonorOverviewComponent },
      { path: 'reporting', component: ReportingComponent },
    ]
  },
  {
    path: "hospital/admin/dashboard",
    component: HospitalAdminComponent,
    canActivate: [authGuard, navigationGuard],
    children: [
      { path: '', redirectTo: 'useroverview', pathMatch: 'full' },
      { path: 'useroverview', component: UserOverviewComponent },
      { path: 'donoroverview', component: DonorOverviewComponent },
      { path: 'billing', component: BillingOverviewComponent },
      { path: 'reporting', component: ReportingComponent },
      {
        path: 'iquestionnaire',
        component: QuestionnaireOverviewComponent,
        data: { templateName: 'initialQuestionnaire' },
      },
      {
        path: 'cquestionnaire',
        component: QuestionnaireOverviewComponent,
        data: { templateName: 'comprehensiveQuestionnaire' },
      }
    ]
  },
  { path: "**", redirectTo: "redirect" }, // Fallback for invalid routes
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
